module.exports = __webpack_public_path__ + "static/scene-digital-1-19128210e1adbc613daeef33dd46d244.png";